/** @format */

import { Component, ElementRef, Inject, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { BookingDataService } from "../../../services/booking-data.service";
import { DrawerRef } from "mis-design-system/drawer";
import { DRAWER_DATA_VAR } from "mis-design-system/drawer";
import { DeleteConfirmationComponent } from "../../forms/delete-confirmation/delete-confirmation.component";
import { Observable, Subject } from "rxjs";
import { ConnectionPositionPair, Overlay, OverlayConfig, OverlayRef } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { take } from "rxjs/operators";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { ConfigurationService } from "../../../services/configuration.service";
import { getAdditionalBookings, parkingTypes } from "../../../functions/booking-utils.functions";
import { ModalService } from "mis-design-system/mis-modal";
import { NsExpWidget } from "../../../models/widgets.models";
import { CommuteService } from "../../../services/commute.service";
@Component({
  selector: "mis-employee-web-exp-upcoming-bookings",
  templateUrl: "upcoming-bookings.component.html",
  styleUrls: ["upcoming-bookings.component.scss"]
})
export class UpcomingBookingsComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  booking: NsEmpWebExpData.IBookingDetailDTOS;
  formHeading = "Your Booking";
  endObs = new Subject<void>();
  opt: boolean = false;
  loginOptPlace: string = "";
  logoutOptPlace: string = "";
  overlayRef: OverlayRef;
  configs: NsWISConfigurations.IConfigurations;
  offices = this.bookingSvc.offices;
  bookingPermissionStream: Observable<NsExpWidget.IBookingValidity>;
  meal = [];
  mealEnitity: NsEmpWebExpData.IMealsEntity[] = [];
  mealEnabled = false;
  parkingData: NsEmpWebExpData.IParkingDetails;
  constructor(
    private bookingSvc: BookingDataService,
    public drawerRef: DrawerRef,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private modals: ModalService,
    @Inject(DRAWER_DATA_VAR) data,
    private configSvc: ConfigurationService,
    private commuteSvc: CommuteService
  ) {
    if (!data || !data.booking || !data.configs) {
      throw new Error("You need to inject data");
    }
    this.booking = data.booking;
    this.configs = data.configs;
    this.bookingPermissionStream = this.configSvc.applyConfigurations(this.booking);
  }

  ngOnInit(): void {
    const parking = getAdditionalBookings(this.booking, parkingTypes);
    this.parkingData = parking
      ? {
          tokenId: parking[0].tokenId,
          tokenName: parking[0].tokenName,
          premiseType: parking[0].premiseType === "PARKING_FOUR" ? "CAR" : "BIKE",
          premiseName: parking[0].premiseName
        }
      : null;
    this.mealEnabled = this.configs.flattenedSettings.mealPlanningEnabled;
    const mealData = getAdditionalBookings(this.booking, ["MEALS"])?.[0]?.extras;
    mealData ? (this.meal = [mealData as NsEmpWebExpData.IMeal]) : (this.meal = undefined);
    this.mealEnitity = this.meal ? [...this.meal?.[0]?.mealData] : undefined;
    this.loginOptPlace = this.transportOptSetter("LOGIN") ? "Cab" : undefined;
    this.logoutOptPlace = this.transportOptSetter("LOGOUT") ? "Cab" : undefined;
    this.opt = this.loginOptPlace || this.logoutOptPlace ? true : false;
  }
  transportOptSetter(direction: string) {
    return (
      (this.booking.requestStatus !== "CANCELLED" &&
        this.booking.userRequestDTOS.find(item => item?.direction === direction && item?.status === "SCHEDULED")) ||
      (this.booking.requestStatus === "CANCELLED" && this.booking.userRequestDTOS.find(item => item?.direction === direction))
    );
  }
  showMenu(template: TemplateRef<ElementRef>, origin: HTMLElement): void {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(origin)
      .withPositions([new ConnectionPositionPair({ originX: "end", originY: "top" }, { overlayX: "end", overlayY: "bottom" })])
      .withPush(true);
    const config = new OverlayConfig({
      hasBackdrop: true,
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      backdropClass: "cdk-overlay-transparent-backdrop"
    });
    this.overlayRef = this.overlay.create(config);
    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef));
    // componentInstance.instance
    this.overlayRef
      .backdropClick()
      .pipe(take(1))
      .subscribe(res => {
        this.overlayRef.detach();
        this.overlayRef.dispose();
      });
  }

  close() {
    this.drawerRef.close();
  }

  closeMenu(type: "Edit" | "Cancel" | "Convert"): void {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
    if (type === "Cancel") {
      this.modals.show(DeleteConfirmationComponent);
      this.close();
    } else if (type === "Edit") {
      this.drawerRef.close(this.booking);
    } else if (type === "Convert") {
      this.drawerRef.close({
        ...this.booking,
        bookingRequestType: this.booking.bookingRequestType === "OFFICE" ? "WFH" : "OFFICE"
      });
    }
  }
}
